var stdin_default = function() {
  function t() {
    this.name = "fontSize";
  }
  return t.prototype.css = function(t2, e) {
    if (t2 && t2.length) {
      if (e) return t2.css("font-size", e + "pt"), "font-size:" + e + "pt";
      t2[0].style.fontSize = "";
    }
    return null;
  }, // 创建 DOM
  t.prototype.createTarget = function() {
    let list = [4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
    let fontSizeList = '\n            <option value="" >\u9ED8\u8BA4</option>';
    list.forEach(function(e) {
      fontSizeList += '\n            <option value="' + e + '">' + e + "pt</option>";
    });
    this.target = hiprintJQuery(' <div class="hiprint-option-item">\n        <div class="hiprint-option-item-label">\n        \u5B57\u4F53\u5927\u5C0F\n        </div>\n        <div class="hiprint-option-item-field">\n        <select class="auto-submit">        </select>\n        </div>\n    </div>');
    this.target.find(".auto-submit").append(hiprintJQuery(fontSizeList));
    return this.target;
  }, // 获取值
  t.prototype.getValue = function() {
    var t2 = this.target.find("select").val();
    if (t2) return parseFloat(t2.toString());
  }, // 设置值
  t.prototype.setValue = function(t2) {
    t2 && (this.target.find('option[value="' + t2 + '"]').length || this.target.find("select").prepend('<option value="' + t2 + '" >' + t2 + "</option>"));
    this.target.find("select").val(t2);
  }, // 销毁 DOM
  t.prototype.destroy = function() {
    this.target.remove();
  }, t;
}();
export {
  stdin_default as default
};
